function debounce(func, delay) {
  let timeout;
  clearTimeout(timeout);
  timeout = setTimeout(func, delay);
}

function checkScrollPosition() {
  debounce(function () {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
  }, 400);
}

window.addEventListener("scroll", checkScrollPosition);

if (document.readyState !== "loading") {
  checkScrollPosition();
} else {
  document.addEventListener("DOMContentLoaded", checkScrollPosition);
}
